// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"380":"fc35815f","430":"2c9865eb","472":"2dca961c","497":"45b036aa"}[chunkId] + ".chunk.js";
};